/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlotGroupSuccessResponse } from '@/api/rest/resources/types/organization';
import {
  DEFAULT_PLOT_GROUP_GROUP_BY,
  PlotGroupFiltersEnum,
  PlotGroupGroupByEnum,
  PlotGroupSortEnum,
  PlotLabelName,
  SortOptions,
} from '@/api/rest/resources/types/plotGroup';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const parsePlotGroupBodyData = (bodyData: PlotGroupSuccessResponse) => {
  const filterDef = bodyData.filter_definition || {};
  const fieldFilters = filterDef.field_filters || [];
  const sortOrders = filterDef.sort_orders || [];
  const groupBy = filterDef.group_by || [];

  const filters = Object.values(PlotGroupFiltersEnum).reduce(
    (acc, key) => {
      const found = fieldFilters.find((f: any) => f.field === key);
      if (found) {
        if (key === PlotGroupFiltersEnum.plot__labels__id) {
          acc[`${key}`] = Array.isArray(found.value) ? found.value.map((id: string) => ({ id })) : [];
        } else {
          acc[`${key}`] = found.value;
        }
      } else if (key === PlotGroupFiltersEnum.plot__crops) {
        acc[`${key}`] = [];
      } else {
        acc[`${key}`] = undefined;
      }
      return acc;
    },
    {} as Record<PlotGroupFiltersEnum, any>,
  );

  const sort = Object.values(PlotGroupSortEnum).reduce(
    (acc, key) => {
      const found = sortOrders.find((s: any) => s.field === key);
      acc[`${key}`] = found ? found.direction : undefined;
      return acc;
    },
    {} as Record<PlotGroupSortEnum, SortOptions | undefined>,
  );

  const parsedGroupBy =
    groupBy.length > 0 && groupBy[0]?.label_name_id
      ? { [PlotGroupGroupByEnum.labels]: { id: groupBy[0].label_name_id } as PlotLabelName }
      : DEFAULT_PLOT_GROUP_GROUP_BY;

  return {
    id: bodyData.id,
    name: bodyData.name,
    filters: filters as any,
    sort: sort as any,
    groupBy: parsedGroupBy,
    additional_plot_ids: bodyData.additional_plot_ids || [],
    active: true,
    total_plots: bodyData.total_plots,
    total_area: bodyData.total_area,
  };
};
